angular.module('FlexyBeautyApp.services')
        .factory('BookingSaveTransactionOrigin', function () {

            return {
                WAITING_SALE: "WaitingSale",
                ADVANCE_SALE: "AdvanceSale",
                SOLD_SALE: "SoldSale",
                CANCELED_SALE: "CanceledSale",
                BOOKING_SERVICE_RESIZE: "BookingServiceResize",
                DRAG_DROP_DIFF_DAY_MULTIPLE: "DragDropDiffDayMultiple",
                DRAG_DROP_DIFF_DAY_SINGLE: "DragDropDiffDaySingle",
                DRAG_DROP_SAME_DAY: "DragDropSameDay",
                SAVE_BUTTON: "SaveButton",
                TOGGLE_STATUS: "ToggleStatus",
                DIRECTIVES_PRO: "DirectivesPro"
            };
        });



// WEBPACK FOOTER //
// ./js/services/views/ConstantsBookingSaveTransactionOrigin.js